import React, { useRef, useState } from 'react';
import { useTranslation } from "react-i18next";
import { ActionButton, DefaultButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Col, Form, Row } from 'react-bootstrap';
import { __MessageTypes } from '../../../common/Dictionaries';
import { base64ToArrayBuffer, getGridLocalization, isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, isNullUndefinedOrEmptyOrZero, saveByteArray, showMessage } from '../../../common/Helpers';
import MessageBoxInfoComplex from '../../../components/Common/Message/MessageBoxInfoComplex';
import PropTypes from 'prop-types';
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import CTextAreaSimple from '../../../components/Common/CTextAreaSimple';
import CLabel from '../../../components/Common/CLabel';
import { useOfGetEdPCommentList } from '../../../hooks/services/sPay/useOfEdPPrepare';
import { deleteDocumentsByIds, downloadDocumentsByIds, setCommentEdP } from '../../../services/sPay/edpConfig.service';
import ReactDOM from 'react-dom';
import { FILE_MAX_SIZE } from '../../../configurations/application.config';
import moment from 'moment';
import { addTransversalDocument } from '../../../services/sBook/document.service';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash-es';
import { action_updateEdpPrepareHeader } from '../../../reducers/actions/PAY/edpPrepareActions';
import { SpinnerSize, TooltipHost } from '@fluentui/react';
import { envBlobDocumentUpload, envDeleteDocument, envDocumentGetUrl, envDocumentValidate } from '../../../services/Env/transversal.service';
import Loading from '../../../components/Templates/Site/Loading';

const SidePanelViewEdPPartieComments = (props) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const { 
        inputParam_Partie = null,
        inputParam_ElementId = null,
        inputParam_EdPId = null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_UserPropsKpi = null

    } = props;

    const {
        _edpPrepareHeader: edpPrepareHeader,
    } = useSelector((state) => state.edpPreparationState);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    const [messageConfigFile, setMessageConfigFile] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    
    const canEdit = !isNullUndefined(inputParam_UserPropsKpi) ? !inputParam_UserPropsKpi.onlyObserver : false;

    const [deleteDownloadInProgress, setDeleteDownloadInProgress] = useState(false);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const fileUploadControl = useRef();
    const [formMode, setFormMode] = useState("add");
    const [objComment, setObjComment] = useState(undefined);
    const [listComments, setListComments] = useState(null);
    const [selectedFile, setSelectedFile] = useState(undefined);
    
    useOfGetEdPCommentList(inputParam_EdPId, !isNullUndefined(inputParam_Partie) ? inputParam_Partie.edP_PARTIDA_ID : null, !isNullUndefined(inputParam_Partie) ? inputParam_Partie.edP_INCREMENTO_ID : null, !isNullUndefined(inputParam_Partie) ? inputParam_Partie.edP_DEDUCCION_ID : null, listComments, setListComments)

    const onDismissPanel = () => {
        showMessage(setMessageConfig, false, null, null)
        inputParam_SetterIsPanelOpen && inputParam_SetterIsPanelOpen(false)
    };

    const onCleanSelectedMessage = () => {
        setFormMode("add")
        setObjComment(undefined);
        setSelectedFile(undefined)
    };

    const validateObject = (object) => {
        let isValid = !isNullUndefinedOrEmpty(object) && !isNullUndefinedOrEmpty(object.textoComentario);

        if (!isValid) {
            setObjComment(prevState => ({
                ...prevState,
                textoComentario: null
            }));
        }
        else {
            showMessage(setMessageConfig, false, __MessageTypes.ERROR, '')
        }

        return isValid ;
    };

    const onCommentChange = (e) => {
        const { value } = e.currentTarget;

        setObjComment && setObjComment(prevState => ({
            ...prevState,
            textoComentario : value,
        }));
    };

    const prepareObjetToSave = () => {
        const property_to_bind = inputParam_Partie !== null ?
        (inputParam_Partie.edP_PARTIDA_ID !== null && inputParam_Partie.edP_PARTIDA_ID !== 0 ? "P" : (inputParam_Partie.edP_INCREMENTO_ID !== null && inputParam_Partie.edP_INCREMENTO_ID !== 0 ? "I" : (inputParam_Partie.edP_DEDUCCION_ID !== null && inputParam_Partie.edP_DEDUCCION_ID !== 0 ? "D" : null))) : null;

        const value_to_bind = inputParam_Partie !== null ?
        (inputParam_Partie.edP_PARTIDA_ID !== null && inputParam_Partie.edP_PARTIDA_ID !== 0 ? inputParam_Partie.edP_PARTIDA_ID : (inputParam_Partie.edP_INCREMENTO_ID !== null && inputParam_Partie.edP_INCREMENTO_ID !== 0 ? inputParam_Partie.edP_INCREMENTO_ID : (inputParam_Partie.edP_DEDUCCION_ID !== null && inputParam_Partie.edP_DEDUCCION_ID !== 0 ? inputParam_Partie.edP_DEDUCCION_ID : null))) : null;

        return {
            id: (objComment === null) ? -1 : objComment.id,
            estadoPagoId: inputParam_EdPId,
            estadoPagoPartidaId: property_to_bind === "P" ? value_to_bind : null,
            estadoPagoIncrementoId: property_to_bind === "I" ? value_to_bind : null,
            estadoPagoDeduccionId: property_to_bind === "D" ? value_to_bind : null,
            textoFijo: "",
            textoComentario: objComment.textoComentario,
            fecha: moment(Date.now()).format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
            automatico: false,
            rol: "",
            userAuthProfileId: 0,
            nombreApellido: "",
            documentoUrl: "",
            documentoLink: "",
            documentId: 0,
        }
    }

    const handleFileInput = (e) => {
        const file = !isNullUndefined(e.target) ? e.target.files[0] : e;
        let flag = false;
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(setMessageConfigFile, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                setSelectedFile(file);
            }
            else {
                flag = true;
                setSelectedFile(file);
                showMessage(setMessageConfigFile, false, __MessageTypes.WARNING, '')
            }
        }

        return flag;
    };

    const onAddComment = async () => {     
        setUploadInProgress(true);
        if (!isNullUndefined(selectedFile)) {
            handleFileInput(selectedFile)
        }
        if (validateObject(objComment)) {
            if (!isNullUndefined(selectedFile)) {
                if (!handleFileInput(selectedFile)) {
                    showMessage(setMessageConfigFile, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                    setUploadInProgress(false);
                    return;
                }
            }

            const objToSave = prepareObjetToSave();
            await setCommentEdP(inputParam_ElementId, objToSave).then(async (serviceResponse) => {
                showMessage(setMessageConfig, false, __MessageTypes.WARNING, t(''))

                if (serviceResponse.data.succeeded) {
                    if (serviceResponse.data.data.result) {
                        if (!isNullUndefined(selectedFile)) {
                            //const formData = new FormData();
                            //formData.append("file", selectedFile);
                            //formData.append('id', serviceResponse.data.data.itemId);
                            //formData.append("url", 'Pay/edp/documents');

                            await envDocumentGetUrl('Pay/edp/documents', serviceResponse.data.data.itemId, selectedFile.name).then(async (responseGetUrl) => {
                                showMessage(setMessageConfigFile, false, __MessageTypes.WARNING, '')
                                if (responseGetUrl.data.succeeded === true) {
                                    await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                                        if (responseAzure.data === "" && responseAzure.status === 201) {
                                            await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                                if (responseValidate.data.succeeded === true) {
                                                    if (responseValidate.data.data.result_validate === true) {
                                                        if (!isNullUndefined(inputParam_Partie)) {
                                                            const aux_edpPrepareHeader = cloneDeep(edpPrepareHeader);

                                                            const property_to_bind = inputParam_Partie !== null ?
                                                            (inputParam_Partie.edP_PARTIDA_ID !== null && inputParam_Partie.edP_PARTIDA_ID !== 0 ? "P" : (inputParam_Partie.edP_INCREMENTO_ID !== null && inputParam_Partie.edP_INCREMENTO_ID !== 0 ? "I" : (inputParam_Partie.edP_DEDUCCION_ID !== null && inputParam_Partie.edP_DEDUCCION_ID !== 0 ? "D" : null))) : null;

                                                            if (property_to_bind === "P") {
                                                                aux_edpPrepareHeader.l_partidas_permiso.find(x => x.partidaId === inputParam_Partie.partidA_ID).hasCommnents = true;
                                                                aux_edpPrepareHeader.l_partidas_permiso.find(x => x.partidaId === inputParam_Partie.partidA_ID).hasDocuments = true;
                                                            }
                                                            else if (property_to_bind === "I" || property_to_bind === "D") {
                                                                aux_edpPrepareHeader.l_partidas_permiso.find(x => x.dI_ID_COMPUESTA === inputParam_Partie.dI_ID_COMPUESTA).hasCommnents = true;
                                                                aux_edpPrepareHeader.l_partidas_permiso.find(x => x.dI_ID_COMPUESTA === inputParam_Partie.dI_ID_COMPUESTA).hasDocuments = true;
                                                            }

                                                            dispatch(action_updateEdpPrepareHeader(aux_edpPrepareHeader))
                                                        }

                                                        setListComments(null);
                                                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                                                        if (fileUploadControl.current) {
                                                            fileUploadControl.current.value = '';
                                                        }
                                                        setObjComment(undefined);
                                                        setSelectedFile(undefined)
                                                        setUploadInProgress(false);
                                                    }
                                                    else {
                                                        setListComments(null);
                                                        showMessage(setMessageConfigFile, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg));
                                                        setUploadInProgress(false);
                                                    }
                                                }
                                                else {
                                                    showMessage(setMessageConfigFile, true, __MessageTypes.ERROR, t(responseValidate.data.message));
                                                    setUploadInProgress(false);
                                                }
                                            })
                                            .catch((error) => {
                                                setListComments(null);
                                                showMessage(setMessageConfigFile, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                                setUploadInProgress(false);
                                            });
                                        }
                                        else {
                                            showMessage(setMessageConfigFile, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                            setUploadInProgress(false);
                                        }
                                    })
                                    .catch(async (error) => {
                                        await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                            setListComments(null);
                                            showMessage(setMessageConfigFile, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                            setUploadInProgress(false);
                                        })
                                        .catch((error) => {
                                            setListComments(null);
                                            showMessage(setMessageConfigFile, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                            setUploadInProgress(false);
                                        });
                                    });
                                } else {
                                    showMessage(setMessageConfigFile, true, __MessageTypes.ERROR, t(responseGetUrl.data.message));
                                    setUploadInProgress(false);
                                }
                                setSelectedFile(undefined)
                            })
                            .catch(() => {
                                showMessage(setMessageConfigFile, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                                setUploadInProgress(false);
                            });
                        }
                        else {
                            if (!isNullUndefined(inputParam_Partie)) {
                                const aux_edpPrepareHeader = cloneDeep(edpPrepareHeader);
                                aux_edpPrepareHeader.l_partidas_permiso.find(x => x.partidaId === inputParam_Partie.partidA_ID).hasCommnents = true;
                                dispatch(action_updateEdpPrepareHeader(aux_edpPrepareHeader))
                            }

                            setListComments(null);
                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                            setUploadInProgress(false);
                        }
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror'));
                        setUploadInProgress(false);
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    setUploadInProgress(false);
                }  
            }).catch((err) => {
                console.log(err)
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setUploadInProgress(false);
            });

        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'));
            setUploadInProgress(false);
        }
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBoxInfoComplex
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                            inputParam_ShowClose={true}
                        />
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBoxInfoComplex
                            inputParam_Message={ messageConfigFile.message }
                            inputParam_Display={ messageConfigFile.showMessage }
                            inputParam_MessageType={ messageConfigFile.messageType }
                            inputParam_SetterMessage={ setMessageConfigFile }
                            inputParam_ShowClose={true}
                        />
                    </Col>
                    <Col xl={12} className='d-flex'>
                        {
                            formMode === 'view' &&
                            <DefaultButton className='mx-2' onClick={ onCleanSelectedMessage }>{ t('data-lang-btn-cancel') }</DefaultButton>
                        }
                        {
                            formMode === 'add' && !uploadInProgress && canEdit &&
                            <PrimaryButton className='mx-2' onClick={ onAddComment }>{ t('data-lang-btn-add') }</PrimaryButton>
                        }
                        {
                            !deleteDownloadInProgress && formMode === 'edit' && !uploadInProgress && canEdit &&
                            <>
                                <PrimaryButton className='mx-2' onClick={ onAddComment }>{ t('data-lang-btn-save') }</PrimaryButton>
                                <DefaultButton className='mx-2' onClick={ onCleanSelectedMessage }>{ t('data-lang-btn-cancel') }</DefaultButton>
                            </>
                        }
                        {
                            deleteDownloadInProgress &&
                            <Loading
                                inputParam_Style={{marginTop: 0}}
                                inputParam_ShowLoading={true}
                                inputParam_ShowText={true}
                                inputParam_Text={t('data-lang-lbl-executing')}
                                inputParam_Position="unset"
                                inputParam_Width="20px"
                                inputParam_Height="20px"
                                inputParam_Vertical={false}
                                inputParam_ColClassName="my-auto"
                                inputParam_EjecutingTextClass={"ps-4"}
                                inputParam_Left="87%"
                                inputParam_Top="11px"
                                inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                            />
                        }
                        {
                            uploadInProgress &&
                                <Loading
                                    inputParam_ShowLoading={true}
                                    inputParam_ShowText={false}
                                    inputParam_Width={'25px'}
                                    inputParam_Height={'25px'}
                                    inputParam_Left={""}
                                    inputParam_Style={{marginTop: 0}}
                                    inputParam_ColClassName={"me-2"}
                                    inputParam_MarginLeft={"auto"}
                                    inputParam_SpinnerSize={SpinnerSize.medium} />
                        }
                        <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                    </Col>
                </Row>
    }

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listComments[rowIndex.boundindex].id;
        }
        return listComments[rowIndex]?.id;
    };

    const getRowFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return listComments[rowIndex.boundindex];
        }
        return listComments[rowIndex];
    };

    const fieldActionHandler = (itemId, actionType) => {
        setFormMode(actionType);
        setObjComment(listComments.find(x => x.id === itemId));
    }

    const onDownloadDocument = (documentList, fileName) => {
        setDeleteDownloadInProgress(true);

        downloadDocumentsByIds(documentList).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
            setDeleteDownloadInProgress(false);
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
        }).catch(() => {
            setDeleteDownloadInProgress(false);
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
        });
    }

    const onDeleteDocument = (documentId) => {
        setDeleteDownloadInProgress(true);
        
        envDeleteDocument(documentId).then((response) => {
            setObjComment(prevState => ({
                ...prevState,
                documentId: null,
                documentoUrl: ""
            }));

            setListComments(null);

            setDeleteDownloadInProgress(false);
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
        }).catch(() => {
            setDeleteDownloadInProgress(false);
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
        });
    }

    const actionCellsRenderer = (objSource) => {
        const itemId = getRowIdFromRowIndex(objSource);
        const currentItem = listComments.find(x => x.id === itemId);

        return  <>
                    {
                        !deleteDownloadInProgress &&
                        <>
                            <IconButton iconProps={{ iconName: 'View' }} title={t('data-lang-lbl-view')} onClick={() => fieldActionHandler(itemId, 'view')} />
                            {
                                currentItem.canEdit === true &&
                                <IconButton iconProps={{ iconName: 'Edit' }} title={t('data-lang-btn-edit')} onClick={() => fieldActionHandler(itemId, 'edit')} />
                            }
                            {
                                !isNullUndefinedOrEmptyOrZero(currentItem.documentId) &&
                                <IconButton iconProps={{ iconName: 'Download' }} title={t('data-lang-btn-download')} onClick={() => onDownloadDocument([currentItem.documentId], currentItem.documentName)} />
                            }
                        </>
                    }
                    {
                        deleteDownloadInProgress &&
                        <Loading
                            inputParam_Style={{marginTop: 10}}
                            inputParam_ShowLoading={true}
                            inputParam_ShowText={true}
                            inputParam_Text={t('data-lang-lbl-executing')}
                            inputParam_Position="unset"
                            inputParam_Width="20px"
                            inputParam_Height="20px"
                            inputParam_Vertical={false}
                            inputParam_ColClassName="my-auto"
                            inputParam_EjecutingTextClass={"ps-4"}
                            inputParam_Left="87%"
                            inputParam_Top="11px"
                            inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                        />
                    }
                </>
    };

    const nameCellsRenderer = (objSource) => {
        const row = getRowFromRowIndex(objSource)
        return  <div className='mt-1 pt-1 ps-1'>
                    {row.nombreApellido}{!isNullUndefinedOrEmpty(row.nombreApellido)?` (${row.rolCliente})`:row.rol}
                </div>
    };

    // Tipo de fila: nota del checklist (viene marcada con el tipo de nota), mensaje automático del flujo del EP
    // (Automatico = true) o comentario escrito por una persona.
    const getTipoComentario = (item) => {
        if (!isNullUndefinedOrEmptyOrZero(item.tipoChecklistReportePdfId)) {
            return 'checklist';
        }

        return item.automatico === true ? 'automatic' : 'manual';
    };

    // Iteración (número de revisión del EP) en la que se creó el comentario; "-" si el mensaje no la guardó.
    const getIteracionTexto = (item) => (isNullUndefinedOrEmpty(item.iteracion) ? '-' : String(item.iteracion));

    const tipoCellsRenderer = (objSource) => {
        const row = getRowFromRowIndex(objSource);
        const tipo = getTipoComentario(row);
        const badgeStyle = { display: 'inline-block', borderRadius: 3, padding: '0 6px', fontSize: 12, fontWeight: 600, lineHeight: '20px', whiteSpace: 'nowrap' };

        if (tipo === 'checklist') {
            const checklistText = t('data-lang-lbl-commenttype-checklistnote');
            const tipoNota = !isNullUndefinedOrEmpty(row.tipoChecklistNombre) ? row.tipoChecklistNombre : null;

            return  <div className='mt-1 pt-1 ps-1 text-truncate' title={tipoNota !== null ? `${checklistText}: ${tipoNota}` : checklistText}>
                        <span style={{ ...badgeStyle, backgroundColor: '#E3F1F4', color: '#005A69' }}>{checklistText}</span>
                        {tipoNota !== null && <span className='ms-1'>{tipoNota}</span>}
                    </div>
        }

        if (tipo === 'automatic') {
            return  <div className='mt-1 pt-1 ps-1 text-truncate'>
                        <span style={{ ...badgeStyle, backgroundColor: '#F3F2F1', color: '#605E5C' }}>{t('data-lang-lbl-commenttype-automatic')}</span>
                    </div>
        }

        return  <div className='mt-1 pt-1 ps-1 text-truncate'>{t('data-lang-lbl-comment')}</div>
    };

    const getFileNameAndExtension = (path) => {
        return !isNullUndefinedOrEmpty(path) ? path.split('/').pop() : "";
    };

    const getHeaderDialogText = () => {
        const property_to_bind = inputParam_Partie !== null ?
            (inputParam_Partie.edP_PARTIDA_ID !== null && inputParam_Partie.edP_PARTIDA_ID !== 0 ? 'data-lang-boxname-viewcommentspartie' : (inputParam_Partie.edP_INCREMENTO_ID !== null && inputParam_Partie.edP_INCREMENTO_ID !== 0 ? 'data-lang-boxname-viewcommentsincrement' : (inputParam_Partie.edP_DEDUCCION_ID !== null && inputParam_Partie.edP_DEDUCCION_ID !== 0 ? 'data-lang-boxname-viewcommentsdeduction' : null))) : null
        
            const partie_or_d_or_i_text = t(property_to_bind)

        const text = inputParam_Partie === null ? t('data-lang-boxname-viewcommentsedp') : partie_or_d_or_i_text;

        return text;
    }

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isBlocking={true}
                onDismiss={ onDismissPanel }
                headerText={ getHeaderDialogText() }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.large }
                type={ PanelType.large }
            >
                <Row>
                    <Col xs={12}>
                        {
                            formMode &&
                            <>
                                {
                                    formMode === 'view' &&
                                    <Row className='pt-3'>
                                        <Col>
                                            <Row>
                                                <Col>
                                                    <CLabel
                                                        labelText={t('data-lang-lbl-user')}
                                                        labelValue={
                                                            !isNullUndefined(objComment)
                                                            ?
                                                            `${objComment.nombreApellido} ${objComment.rol}` : '-'
                                                        }
                                                    />
                                                </Col>
                                                <Col className='col-auto me-auto'>
                                                    <CLabel
                                                        labelText={t('data-lang-lbl-date')}
                                                        labelValue={!isNullUndefined(objComment) ? moment(objComment.fecha).format('DD/MM/YYYY') : '-'}
                                                    />
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                }
                                <Row className='pt-3'>
                                    {
                                        (formMode === 'add' || formMode === 'edit') && canEdit &&
                                        <Col>
                                            <CTextAreaSimple
                                                editMode={true}
                                                //maxLength={1000}
                                                labelText={t('data-lang-lbl-comment')}
                                                controlValue={objComment ? objComment.textoComentario : ''}
                                                textBoxName={'action'}
                                                setterControlValue={onCommentChange}
                                                isInvalirControl={objComment ? isNullOrEmpty(objComment.textoComentario) : false}
                                            />
                                        </Col>
                                    }
                                    {
                                        formMode === 'view' && objComment &&
                                        <Col className='border mb-2' style={{height: "200px"}}>
                                            <CLabel labelText={t('data-lang-lbl-comment')}/>
                                            <p> {objComment.textoComentario} </p>
                                        </Col>
                                    }
                                </Row>
                                {
                                    (formMode === 'add' || (formMode === 'edit' && objComment && !objComment.documentoUrl)) && canEdit &&
                                    <Row className='py-3'>
                                        <Col><b>{t('data-lang-msg-documentasociated')}</b></Col>
                                        <Col>
                                            <TooltipHost content={
                                                <>
                                                    <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                                                    <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                                                </>
                                            }>
                                                <Form.Control ref={fileUploadControl} type="file" size="sm" onChange={ handleFileInput } />
                                            </TooltipHost>
                                        </Col>
                                    </Row>
                                }
                            </>
                        }
                        {
                            objComment && !isNullUndefinedOrEmpty(objComment.documentoUrl) &&
                            <Row>
                                <Col className='col-auto'>
                                    {
                                        !deleteDownloadInProgress && objComment && objComment.documentoUrl && (objComment.documentoUrl.toLowerCase().startsWith("https://") || objComment.documentoUrl.toLowerCase().startsWith("http://")) &&
                                        <>
                                            {
                                                objComment.canEdit && (formMode === 'edit') && canEdit &&
                                                <ActionButton iconProps={{ iconName: 'Delete' }} title={t('data-lang-btn-delete')} onClick={() => onDeleteDocument(objComment.documentId)} />
                                            }

                                            <ActionButton iconProps={{iconName: "Download"}} onClick={() => onDownloadDocument([objComment.documentId], objComment.documentName)}>{ objComment.documentName }</ActionButton>
                                        </>
                                    }
                                    {
                                        objComment && objComment.documentoUrl && (!objComment.documentoUrl.toLowerCase().startsWith("https://") && !objComment.documentoUrl.toLowerCase().startsWith("http://")) &&
                                        <span>{t('data-lang-msg-documentnotavailable')}</span>
                                    }
                                    {
                                    deleteDownloadInProgress &&
                                    <Loading
                                        inputParam_Style={{marginTop: 0}}
                                        inputParam_ShowLoading={true}
                                        inputParam_ShowText={true}
                                        inputParam_Text={t('data-lang-lbl-executing')}
                                        inputParam_Position="unset"
                                        inputParam_Width="20px"
                                        inputParam_Height="20px"
                                        inputParam_Vertical={false}
                                        inputParam_ColClassName="my-auto"
                                        inputParam_EjecutingTextClass={"ps-4"}
                                        inputParam_Left="87%"
                                        inputParam_Top="11px"
                                        inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                                    />
                                    }
                                </Col>
                            </Row>
                        }
                        <a id="btnDownloadDocumentFromList" rel="noreferrer noopener" target={'_blank'} className='d-none' />
                        {
                            objComment && objComment.documentoUrl && (objComment.documentoUrl.toLowerCase().startsWith("https://") || objComment.documentoUrl.toLowerCase().startsWith("http://")) &&
                            <a id="btnDownloadDocument" download={getFileNameAndExtension(objComment.documentoUrl)} rel="noreferrer noopener" target={'_blank'} className='d-none' href={objComment.documentoUrl} />
                        }
                        <div>
                            <h4>{t('data-lang-lbl-commentlist')}</h4>
                            {
                                !isNullUndefined(listComments) &&
                                <JqxGrid
                                    altrows={true}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    autoheight={true}
                                    editable={false}
                                    pageable={false}
                                    sortable={false}
                                    filterable={false}
                                    showfilterrow={false} 
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listComments.map(item => ({ ...item, tipoComentario: getTipoComentario(item), iteracionTexto: getIteracionTexto(item) })),
                                        dataType: 'array',
                                        dataFields: [
                                            { name: 'id',                  type: 'number' },
                                            { name: 'estadoPagoId',        type: 'number' },
                                            { name: 'estadoPagoPartidaId', type: 'number' },
                                            { name: 'textoFijo',           type: 'string' },
                                            { name: 'textoComentario',     type: 'string' },
                                            { name: 'nombreApellido',      type: 'string' },
                                            { name: 'rol',                 type: 'string' },
                                            { name: 'userAuthProfileId',   type: 'string' },
                                            { name: 'fecha',               type: 'date' },
                                            { name: 'automatico',          type: 'string' },
                                            { name: 'tipoChecklistReportePdfId', type: 'number' },
                                            { name: 'tipoChecklistNombre', type: 'string' },
                                            { name: 'tipoComentario',      type: 'string' },
                                            { name: 'iteracionTexto',      type: 'string' },
                                            { name: 'documentoUrl',        type: 'string' },
                                            { name: 'documentoLink',       type: 'string' },
                                            { name: 'documentId',          type: 'number' },
                                        ],
                                        id: 'id'
                                    })}
                                    columns={[
                                        { index: null, text: 'ID',                       dataField: 'id',             width: '0%',  columntype: 'textbox', editable: false, hidden: true },
                                        { index: 0,    text: t('data-lang-lbl-comment'), dataField: 'textoComentario',width: '36%', columntype: 'textbox', editable: false },
                                        { index: 1,    text: t('data-lang-lbl-type'),    dataField: 'tipoComentario', width: '29.59%', columntype: 'textbox', editable: false,
                                            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(tipoCellsRenderer(row), htmlElement); },
                                            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(tipoCellsRenderer(row), htmlElement); },
                                        },
                                        { index: 2,    text: t('data-lang-lbl-iteration'), dataField: 'iteracionTexto', width: '5.33%', columntype: 'textbox', editable: false, align: 'center', cellsalign: 'center' },
                                        { index: 3,    text: t('data-lang-lbl-name'),    dataField: 'nombreApellido', width: '19%', columntype: 'textbox', editable: false,
                                            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(nameCellsRenderer(row), htmlElement); },
                                            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(nameCellsRenderer(row), htmlElement); },
                                        },
                                        { index: 4,    text: t('data-lang-lbl-date'),    dataField: 'fecha',          width: '5.63%', columntype: 'datetimeinput', editable: false, cellsformat: 'dd/MM/yyyy', cellsalign: 'right' },
                                        { index: null, text: t('data-lang-lbl-actions'), dataField: 'acciones',       width: '4.45%',
                                            createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                                            initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                                        },
                                    ]}
                                />
                            }
                        </div>
                    </Col>
                </Row>
            </Panel>
        </div>
    );
};

SidePanelViewEdPPartieComments.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
};

export default SidePanelViewEdPPartieComments;